import './Home.scss';

import { Component } from '../../components/Component';
import { FiSubHeaderService } from './../../components/FiSubHeader/FiSubHeaderService';
import { FiFurnitureService } from '../../components/fiFurniture/FiFurnitureService';
import { FiCart } from '../../services/Cart';
import { FiPrice } from '../../services/Price';
import { FiHubspotService } from '../../services/Hubspot';
import * as angular from 'angular';

import lightGallery from "lightgallery";
import lgThumbnail from "lightgallery/plugins/thumbnail";

@Component({
    controllerAs: 'vm',
    template: require('./Home.html'),
    bindings: {
    }
})
export class Home {
    static $inject = [
        '$scope',
        '$locale',
        '$timeout',
        'fiSubHeaderService',
        '$window',
        'fiFurnitureService',
        '$http',
        'fiCart',
        'fiPrice',
        '$mdDialog',
        'fiHubspotService',
    ];

    activeDukItem: number;
    galleryPic: number = 1;
    image_1: File;
    galleryFade: boolean;
    
    cName: string;
    cLastname: string;
    cEmail: string;
    cPhone: string;
    cDescription: string;
    cConsultation: boolean;

    thanks: boolean = false;
    recaptchaToken: string;

    constructor(
        private $scope: angular.IScope,
        private $locale: angular.ILocaleService,
        private $timeout: angular.ITimeoutService,
        private fshs: FiSubHeaderService,
        private $window: angular.IWindowService,
        private fs: FiFurnitureService,
        private $http: angular.IHttpService,
        private cart: FiCart,
        private ps: FiPrice,
        private $mdDialog: angular.material.IDialogService,
        private hubspot: FiHubspotService,
    ) {
        /* */
    }

    data = [];
    gallery = [];
    cartStorage: FiCart;
    dialogTemplate: string;

    $onInit() {
        this.fshs.subHeaderIsHidden = false;

        // Items
        this.$http.get('https://www.fitit.lt/db/items.php').then((data) => {
            this.data.push(data);
        });

        // Gallery
        this.$http.get('https://www.fitit.lt/db/admin-gallery.php').then((data) => {
            this.gallery.push(data);
        });

        this.swapImage();

        this.$timeout(() => {
            this.constructGallery();
        }, 1000);

    }

    constructGallery() {
        const $galleryContainer = document.getElementById("gallery-container");

        const lg = lightGallery($galleryContainer, {
            speed: 500,
            plugins: [lgThumbnail],
            enableDrag: false,
            selector: '.item-details-gallery-item',
            enableSwipe: true,
            download : false,
            controls: true,
            closeOnTap  : false,
            mobileSettings: {
                showCloseIcon: true,
                controls: true,
            }
        });

        lg.outer.on("click", (e) => {
        const $item = lg.outer.find(".lg-current .lg-image");
        if (
            e.target.classList.contains("lg-image") ||
            $item.get().contains(e.target)
        ) {
            lg.goToNextSlide();
        }
        });
    }

    getImageUrl(url: string) {
        return 'https://www.fitit.lt/gallery/' + url;
    }

    getImageTypeName(type: number) {

        if (type == 0) {
            return 'Galerija'
        }
        else if (type == 1) {
            return 'Spintos varstomomis durimis'
        }
        else if (type == 2) {
            return 'Spintos stumdomomis durimis'
        }
        else if (type == 3) {
            return 'Komodos'
        }
        else if (type == 4) {
            return 'Lentynos'
        }
        else if (type == 5) {
            return 'TV Spintelės'
        }
        else if (type == 6) {
            return 'Spintelės'
        }
    }

    swapImage() { 
        this.galleryFade = !this.galleryFade;

        this.$timeout(() => {
            this.swapImage();
        }, 5000);

    } 

    viewImage(img: string) {
        this.$window.open('https://www.fitit.lt/gallery/' + img, '_blank');
    }

    showChoosePlates() {

        this.dialogTemplate = '<fi-modal-top-five></fi-modal-top-five>';
        this.$mdDialog.show({
            template: this.dialogTemplate,
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            controllerAs: 'vm'
        });
    }

    toggleDuk(listItem: number) {
        this.activeDukItem = listItem;
    }

    goToConfiguratorNewItem() {
        this.$window.location.href = '/konfiguratorius/';
    }

    changeGalleryPic(picNo: number) {

        if (picNo < 1 || picNo > 9) {
            return
        }
        
        this.galleryPic = picNo;
    }

    viewDetails(item_id: string) {
        this.$window.location.href = '/baldai/' + item_id;
    }

    goToConfigurator(item_id: string) {
        this.$window.location.href = '/konfiguratorius/' + item_id;
    }

    addToCart(item_id: string) {

        this.data = [];

        this.$http.get('https://www.fitit.lt/db/item.php?id=' + item_id).then((data) => {
            this.data.push(data);
            this.fs.setFurniture(false, this.data);

            this.cartStorage = JSON.parse(localStorage.getItem('cart'));
        
            if (this.cartStorage) {
                this.cart.items = this.cartStorage.items;
            }
            
            this.cart.items.push({
                item: this.fs.furniture,
                count: 1,
                assemblyPrice: this.ps.getAssemblyPrice(),
                carryPrice: this.ps.getCarryPrice()
            });

            this.cart.count = this.cart.items.length;
            this.cart.environment = this.fs.environment;

            localStorage.setItem('cart', JSON.stringify(this.cart));

            window['dataLayer'] = window['dataLayer'] || [];
            window['dataLayer'].push({ ecommerce: null });  // Clear the previous ecommerce object.
            window['dataLayer'].push({
            'event': 'addToCart',
            'ecommerce': {
                'currencyCode': 'EUR',
                'add': {                                // 'add' actionFieldObject measures.
                'products': [{                        //  adding a product to a shopping cart.
                    'name': this.fs.furniture.title,
                    'id': this.fs.furniture.item_id,
                    'price': this.fs.furniture.price,
                    'quantity': 1
                }]
                }
            }
            });

            this.$window.location.href = '/krepselis';
        });


        

    }

    showReloadDialog(type: number) {
    
        if (type == 1) {
            this.dialogTemplate = '<fi-modal-top-one></fi-modal-top-one>';
        }
        else if (type == 2) {
            this.dialogTemplate = '<fi-modal-top-two></fi-modal-top-two>';
        }
        else if (type == 3) {
            this.dialogTemplate = '<fi-modal-top-three></fi-modal-top-three>';
        }
        else if (type == 4) {
            this.dialogTemplate = '<fi-modal-top-four></fi-modal-top-four>';
        }
        else if (type == 5) {
            this.dialogTemplate = '<fi-modal-top-five></fi-modal-top-five>';
        }
        else if (type == 6) {
            this.dialogTemplate = '<fi-modal-top-six></fi-modal-top-six>';
        }
        else if (type == 7) {
            this.dialogTemplate = '<fi-modal-top-seven></fi-modal-top-seven>';
        }


        this.$mdDialog.show({
            template: this.dialogTemplate,
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            controllerAs: 'vm'
        });
    }

    sendOLD() {
        this.$http.post("https://www.fitit.lt/db/request.php", { 

            name: this.cName,
            email: this.cEmail,
            phone: this.cPhone,
            description: this.cDescription,
            consulation: this.cConsultation

        }, { headers: {'Content-Type': 'application/json'} })
            .then(function (response) {

                // console.log(response);

                if(response.data == 'return') {
                    // alert('return');
                }
                else {
                    
                }
                return;

        });

        // this.thanks = true;
    }

    
    send() {
        this.hubspot.submit(this.recaptchaToken, 'www.fitit.lt', 'Užklausos tipas: Forma', [
            { name: 'email', value: this.cEmail },
            { name: 'firstname', value: this.cName },
            { name: 'lastname', value: this.cLastname },
            { name: 'message', value: this.cDescription + '\n' + (this.cConsultation === true ? 'Konsultacija reikalinga' : 'Konsultacijos nereikia') },
            { name: 'phone', value: this.cPhone },
            { name: 'salutation', value: 'Užklausos tipas: Forma' },
        ]);

        this.thanks = true;

        this.sendOLD();
    }

    getType(type: number) {
        if (type == 1) {
            return 'Spinta su varstomomis durimis';
        }
        else if (type == 2) {
            return 'Spinta su stumdomomis durimis';
        }
        else if (type == 3) {
            return 'Komoda';
        }
        else if (type == 4) {
            return 'Lentyna';
        }
        else if (type == 5) {
            return 'TV spintelė';
        }
        else if (type == 6) {
            return 'Spintelė';
        }
    }
}
